export default __webpack_public_path__ + "static/media/avatar.965446f2.svg";